import React from "react";
import "./index.css";
import CarouselComponent from "../CarouselComponent/CarouselComponent";
import HomeProducts from "../HomeProducts/HomeProducts";
import OurProcessAndServices from "../OurProcessAndServices/OurProcessAndServices";
import BenefitsOffered from "../Benifits/benifits";
import SuccessJourney from "../SuccessJourney/SuccessJourney";
import BusinessProfile from "../BusinessProfile/BusinessProfile";

const benefits = [
  { title: 'Benifits_1', description: 'Description for Benifits_1', headingClass: 'benefit-heading-1' },
  { title: 'Benifits_2', description: 'Description for Benifits_2', headingClass: 'benefit-heading-2' },
  { title: 'Benifits_3', description: 'Description for Benifits_3', headingClass: 'benefit-heading-3' },
];

const Hero = () => {
  return (
    <>
      <div className="snow-animation"></div>
      <CarouselComponent />
      <div className="container">
        <HomeProducts />
        <OurProcessAndServices />
        <BenefitsOffered benefits={benefits} />
        <BusinessProfile />
        <SuccessJourney />
        <p className="EFE">Emerging Farmers Empowerment</p>
      </div>
    </>
  );
};

export default Hero;
